// Add new property here when adding new supported app
// Refer to https://opswat.atlassian.net/wiki/spaces/MON/pages/1231257718/SSO+Add+a+new+App

import { OPSWAT_PRIVACY_POLICY_URL, OPSWAT_TERMS_OF_SERVICE_URL } from 'services/Constant';
import opswatDefaultLogo from '../assets/images/logo.svg';
import metaAccessLogo from '../assets/images/product-logos/MetaDefender_Access-IT.svg';
import metadefenderCloudLogo from '../assets/images/product-logos/MetaDefender_Cloud.svg';
import mdcesLogo from '../assets/images/product-logos/MetaDefender_Cloud_Email_Security.svg';
import myOCM from '../assets/images/product-logos/My_OPSWAT_Central_Management.svg';
import myOpswatLogo from '../assets/images/product-logos/MyOPSWAT.svg';
import opswatAcademyLogo from '../assets/images/product-logos/Opswat_Academy.png';

export default {
    MA: {
        name: 'MetaDefender IT Access',
        shortname: 'MetaDefender IT Access',
        productPrefix: 'MetaDefender',
        productName: 'IT Access',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        info: [
            'Register to enable the Free Product Trial, this will allow you full access to the product for up to 50 devices.',
            'After registering we will send a confirmation email and then you are able to start using the product. Additional help can be found via our Video Setup Guides.'
        ],
        logo: <img className='customLogo' src={metaAccessLogo} alt={'MetaDefender IT Access'} />,
        ...(process.env.REACT_APP_customHosts_MA && { customHosts: process.env.REACT_APP_customHosts_MA }),
        ...(process.env.REACT_APP_signin_MA && { signin: process.env.REACT_APP_signin_MA }),
        domainsOnly: false
    },

    MDC: {
        name: 'Metadefender Cloud',
        shortname: 'Metadefender Cloud',
        productPrefix: 'MetaDefender',
        productName: 'Cloud',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={metadefenderCloudLogo} alt={'Metadefender Cloud'} />,
        ...(process.env.REACT_APP_customHosts_MDC && { customHosts: process.env.REACT_APP_customHosts_MDC }),
        ...(process.env.REACT_APP_signin_MDC && { signin: process.env.REACT_APP_signin_MDC }),
        domainsOnly: false
    },

    MDCES: {
        name: 'OPSWAT Metadefender Cloud Email Security',
        shortname: 'Metadefender Cloud Email Security',
        productPrefix: 'MetaDefender',
        productName: 'Cloud Email Security',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo invertBrightLogo' src={mdcesLogo} alt={'Metadefender Cloud Email Security'} />,
        ...(process.env.REACT_APP_customHosts_MDCES && { customHosts: process.env.REACT_APP_customHosts_MDCES }),
        ...(process.env.REACT_APP_signin_MDCES && { signin: process.env.REACT_APP_signin_MDCES }),
        domainsOnly: false
    },

    SKL: {
        name: 'OPSWAT Academy',
        shortname: 'Academy',
        productPrefix: 'OPSWAT',
        productName: 'Academy',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={opswatAcademyLogo} alt={'Academy'} />,
        ...(process.env.REACT_APP_customHosts_SKL && { customHosts: process.env.REACT_APP_customHosts_SKL }),
        ...(process.env.REACT_APP_signin_SKL && { signin: process.env.REACT_APP_signin_SKL }),
        domainsOnly: false
    },

    OCM: {
        name: 'OPSWAT OCM',
        shortname: 'My OPSWAT',
        productPrefix: 'My OPSWAT',
        productName: 'OCM',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo invertBrightLogo' src={myOpswatLogo} alt={'My OPSWAT'} />,
        ...(process.env.REACT_APP_customHosts_OCM && { customHosts: process.env.REACT_APP_customHosts_OCM }),
        ...(process.env.REACT_APP_signin_OCM && { signin: process.env.REACT_APP_signin_OCM }),
        domainsOnly: false
    },

    MyOPSWAT: {
        name: 'My OPSWAT Portal',
        shortname: 'My OPSWAT Portal',
        productPrefix: 'My OPSWAT',
        productName: 'Portal',
        title: 'My OPSWAT Portal - One-stop Hub for Customers and Partners',
        description:
            'My OPSWAT Portal brings together licenses, product resources, learning, and support, all in one secure and efficient place.',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo invertBrightLogo' src={myOpswatLogo} alt={'My OPSWAT Portal'} />,
        ...(process.env.REACT_APP_customHosts_MyOPSWAT && { customHosts: process.env.REACT_APP_customHosts_MyOPSWAT }),
        ...(process.env.REACT_APP_signin_MyOPSWAT && { signin: process.env.REACT_APP_signin_MyOPSWAT }),
        domainsOnly: false
    },

    OESISCloud: {
        name: 'OESIS Cloud',
        shortname: 'OESIS Cloud',
        productPrefix: 'OESIS',
        productName: 'Cloud',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={myOpswatLogo} alt={'OESIS Cloud'} />,
        ...(process.env.REACT_APP_customHosts_OESISCloud && {
            customHosts: process.env.REACT_APP_customHosts_OESISCloud
        }),
        ...(process.env.REACT_APP_signin_OESISCloud && { signin: process.env.REACT_APP_signin_OESISCloud }),
        domainsOnly: false
    },

    OPSWATStore: {
        name: 'OPSWAT Store',
        shortname: 'OPSWAT Store',
        productPrefix: 'OPSWAT',
        productName: 'Store',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={myOpswatLogo} alt={'OPSWAT Store'} />,
        ...(process.env.REACT_APP_customHosts_OPSWATStore && {
            customHosts: process.env.REACT_APP_customHosts_OPSWATStore
        }),
        ...(process.env.REACT_APP_signin_OPSWATStore && { signin: process.env.REACT_APP_signin_OPSWATStore }),
        domainsOnly: false
    },

    AS: {
        name: 'Activation Server',
        shortname: 'AS',
        productPrefix: 'MetaDefender',
        productName: 'Activation Server',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={myOpswatLogo} alt={'AS'} />,
        ...(process.env.REACT_APP_customHosts_AS && { customHosts: process.env.REACT_APP_customHosts_AS }),
        ...(process.env.REACT_APP_signin_AS && { signin: process.env.REACT_APP_signin_AS }),
        domainsOnly: false
    },

    MDGateway: {
        name: 'Metadefender Gateway',
        shortname: 'MetaDefender Cloud Email Security',
        productPrefix: 'MetaDefender',
        productName: 'Cloud Email Security',
        termsUrl: OPSWAT_TERMS_OF_SERVICE_URL,
        policyUrl: OPSWAT_PRIVACY_POLICY_URL,
        logo: <img className='customLogo' src={myOpswatLogo} alt={'MDGateway'} />,
        ...(process.env.REACT_APP_customHosts_MDGateway && {
            customHosts: process.env.REACT_APP_customHosts_MDGateway
        }),
        ...(process.env.REACT_APP_signin_MDGateway && { signin: process.env.REACT_APP_signin_MDGateway }),
        domainsOnly: false
    },

    Impartner: {
        name: 'Impartner',
        shortname: 'Impartner',
        productName: 'Impartner',
        logo: (
            <>
                <img className='originLogo' src={opswatDefaultLogo} alt={'OPSWAT Logo'} />
                <span className='productLogoTitle'>Impartner</span>
            </>
        ),
        ...(process.env.REACT_APP_customHosts_Allbound && { customHosts: process.env.REACT_APP_customHosts_Allbound }),
        ...(process.env.REACT_APP_signin_Allbound && { signin: process.env.REACT_APP_signin_Allbound }),
        domainsOnly: false
    },
    MDSS: {
        name: 'MetaDefender Storage Security Cloud',
        shortname: 'MetaDefender Storage Security Cloud',
        productPrefix: 'MetaDefender',
        productName: 'Storage Security Cloud',
        logo: (
            <>
                <img className='originLogo' src={opswatDefaultLogo} alt={'OPSWAT Logo'} />
                <span className='productLogoTitle'>MetaDefender Storage Security Cloud</span>
            </>
        ),
        ...(process.env.REACT_APP_customHosts_Allbound && { customHosts: process.env.REACT_APP_customHosts_Allbound }),
        ...(process.env.REACT_APP_signin_Allbound && { signin: process.env.REACT_APP_signin_Allbound }),
        domainsOnly: false
    },
    SB: {
        name: 'Filescan IO',
        shortname: 'Filescan IO',
        productName: 'Filescan IO',
        logo: (
            <>
                <img className='originLogo' src={opswatDefaultLogo} alt={'OPSWAT Logo'} />
                <span className='productLogoTitle'>Filescan IO</span>
            </>
        ),
        domainsOnly: false
    },
    Fusion: {
        name: 'My OPSWAT Central Management',
        shortname: 'My OPSWAT Central Management',
        productPrefix: 'My OPSWAT',
        productName: 'Central Management',
        logo: <img className='customLogo' src={myOCM} alt={'My OPSWAT Central Management'} />,
        ...(process.env.REACT_APP_customHosts_Fusion && { customHosts: process.env.REACT_APP_customHosts_Fusion }),
        ...(process.env.REACT_APP_signin_Fusion && { signin: process.env.REACT_APP_signin_Fusion }),
        domainsOnly: false
    },
    SKA: {
        name: 'OPSWAT Academy Lab',
        shortname: 'OPSWAT Academy Lab',
        productPrefix: 'OPSWAT',
        productName: 'Academy Lab',
        logo: (
            <>
                <img className='originLogo' src={opswatDefaultLogo} alt={'OPSWAT Logo'} />
                <span className='productLogoTitle'>OPSWAT Academy Lab</span>
            </>
        ),
        domainsOnly: false
    },
    OELC: {
        name: 'OPSWAT Employee Learning Center',
        shortname: 'OPSWAT Employee Learning Center',
        productPrefix: 'OPSWAT',
        productName: 'Employee Learning Center',
        logo: (
            <>
                <img className='originLogo' src={opswatDefaultLogo} alt={'OPSWAT Logo'} />
                <span className='productLogoTitle'>OPSWAT Employee Learning Center</span>
            </>
        ),
        domainsOnly: true
    }
};
